import React from "react";
import { Alert } from "@mui/material";
import { OXFORD_WINDOWS, HAMPTON_WINDOWS } from "../Constants/constants";;

const WindowOptions = ({ selectedDesign, selctwindow, setSelectWindow }) => {
  const renderWindowGrid = (windows) => (
    <div className="d-flex align-items-center justify-content-between flex-wrap">
      <div className="w-100 d-flex window-box flex-wrap">
        {windows.map((window) => (
          <div
            key={window.id}
            className="mb-3 mt-3 justify-content-center"
            style={{ width: "45%" }}
          >
            <div
              className="d-grid selected-window"
              onClick={() =>
                document.getElementById(`window-${window.name}`).click()
              }
              style={{ cursor: "pointer" }}
            >
              <input
                type="radio"
                name="windowType"
                id={`window-${window.name}`}
                style={{ width: "max-content" }}
                className="hidden-radio"
                checked={selctwindow === window.name}
                onChange={() => setSelectWindow(window.name)}
              />
              <img
                src={window.img}
                alt={window.name}
                className="img-fluid window-img ms-1"
              />
              <label htmlFor={`window-${window.name}`}>
                {window.name}
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <h5>Window Options</h5>
      {selectedDesign === "Oxford" && renderWindowGrid(OXFORD_WINDOWS)}
      {selectedDesign === "Hampton" && renderWindowGrid(HAMPTON_WINDOWS)}
      {selectedDesign !== "Hampton" && selectedDesign !== "Oxford" && (
        <Alert severity="error" className="mb-2">
          Sorry, this model is not available with windows
        </Alert>
      )}
    </>
  );
};

export default WindowOptions;